export const resources = {
  tm: {
    translation: {
      layoutHome: 'Türkmenistanyň Prezidenti Serdar Berdimuhamedow: ',
      layoutHome2: '',
      // navbar
      home: 'Baş sahypa',
      laws_codes: 'Kadalaşdyryjy hukuk namalar',
      about: 'Kazyýet barada',
      online_services: 'Onlaýn hyzmatlar',
      services: 'Hyzmatlar',
      news: 'Maglumat merkezi',
      contacts: 'Salgylar',
      sign_in: 'Ulgama gir',
      tm_laws: 'Türkmenistanyň kanunlary',
      tm_codex: 'Türkmenistanyň kodeksleri',
      tm_constitution: 'Türkmenistanyň Konstitusiýasy',
      tm_constitutionlaws: 'Türkmenistanyň konstitusion kanunlary',
      darkmode: 'Garaňky ekran',
      lightmode: 'Ýagty ekran',
      // pages
      all_news: 'Ähli habarlar',
      photomaterials: 'Suratlar',
      useful_sites: 'Peýdaly saýtlar',
      branches: 'Kazyýet edaralary',
      confiscated: 'Konfiskasiýa edilen emläk',
      online_appeals: 'Onlaýn ýüztutmalar',
      appeals: 'Ýüztutmalar',
      state_duty: 'Döwlet pajy',
      collection_decisions: "TÝK-niň Plenumynyň kararlarynyň ýygyndysy",
      legal_assistance: 'Hukuk maslahaty',
      legal_assistance_desc: 'Size islendik wagt gerek maglumatlary tapmaga taýýar',
      faq: 'Gyzyklanylýan soraglar',
      auction: 'Auksion',
      country_news: 'Ýurt habarlary',
      judicial_news: 'Kazyýet edaralarynyň habarlary',
      article: 'Makala',
      event: 'Çäreler',
      media: 'Media',
      personal_room: 'Şahsy otag',
      personal_inform: 'Şahsy maglumatlar',
      profile: 'Profil',
      auction_appeals: 'Auksion ýüztutmalar',
      logout: 'Hasapdan çykmak',
      RECEIPT: 'Nagt töleg',
      ONLINE: 'Onlaýn töleg',
      ACCEPTED: 'Kabul edildi',
      REJECTED: 'Kabul edilmedi',
      IN_PROGRESS: 'Garaşylýar',
      full_name: 'Doly ady',
      property_name: 'Emlägiň ady',
      content: 'Maglumat',
      date: 'Sene',
      status: 'Ýagdaýy',
      payment_type: 'Töleg görnüşi',
      type: 'Görnüşi',
      sale: 'Kazyýetiñ karary esasynda satylýan emläkler',
      select: 'Saýlamak',
      select_category: 'Berlen edarany saýlaň',
      select_type: 'Namanyň görnüşini saýlaň',
      judgment: 'Höküm',
      solution: 'Çözgüt',
      definition: 'Kazyýet kararynyň esasynda',
      price: 'Baha',
      min_price: 'Baha: iň pes',
      max_price: 'Baha: iň ýokary',
      search: 'Gözle',
      search_result: 'Gözlegiň netijesi:',
      info: 'Maglumat',
      legal_status: 'Kanuny ýagdaýy',
      ARRESTED: 'Tussag edilen',
      organizer: 'Guramaçy',
      telephone: 'Telefon belgi',
      address: 'Salgy',
      closing_date: 'Ýüztutmalaryň ýapylýan senesi',
      trading_date: 'Bäsleşikli söwdanyň geçiriljek senesi',
      trading_place: 'Geçiriljek ýeri',
      apply: 'Ýüz tutmak',
      calculator: 'Kalkulýator',
      count: 'Hasapla!',
      calculation_type_label: 'Kazyýetde tölegleriň hasaplanyşygyň görnüşlerini saýlaň',
      is_working: 'Töleýji işleýärmi?',
      payers_salary: 'Töleýjiniň aýlyk haky (girdeji salgytsyz)',
      child_number: 'Çaga sany',
      average_salary: '2025-nji ýylyň tassyklanan ortaça zähmet haky',
      paid_alimony: 'Aliment bermeli möçberi',
      calculated: 'Siziň beren maglumatlaryňyza görä hasaplanylýar',
      nothing_found: 'Hiç zat tapylmady',
      yes: 'Hawa',
      no: 'Ýok',
      application_procedure: 'Arza beriş tertibi',
      institution_name: 'Ederanyň ady',
      job: 'Wezipesi',
      select_province: 'Welaýat saýlaň',
      select_county: 'Etrap saýlaň',
      write_name: 'Adyňyzy ýazyň',
      write_surname: 'Familýaňyzy ýazyň',
      write_patronymic: 'Atasynyň adyny ýazyň',
      write_address: 'Salgyňyzy ýazyň',
      your_message: 'Siziň hatyňyz',
      choose_file: 'Faýl saýlamak',
      attach_file: 'Faýllaryňyz bar bolsa birikdiriň',
      send: 'Ugratmak',
      chosen: 'Saýlanan faýllar',
      appeal_type: 'Ýüz tutmanyň görnüşini saýlaň',
      birthday: 'Doglan senesi',
      passport_copy: 'Passport nusga',
      duty_amount: 'Kesgitlenen döwlet pajynyň möçberleri',
      phone_number: 'Telefon belgi',
      show_map: 'Kartada görkez',
      supreme_court: 'Türkmenistanyň',
      turkmenistan: 'Ýokary Kazyýeti',
      save: 'Ýatda sakla',
      check: 'Barlamak',
      request_copies: 'Kazyýet namalarynyň nusgalaryny soramak',
      list_cases: 'Seretmäge bellenen işleriň sanawy',
      recipient: 'Kabul ediji',
      law_help: 'Raýatlaryň kabul edişligi',
      accept_time: 'Kabul ediliş wagty',
      receiving_citizens: 'Raýatlary kabul etmegiň tertibi',
      receiving_time_days: 'Duşenbe-anna günleri 10: 00-dan 13: 00-a çenli',
      receiving_time_week: 'Şenbe 09: 00-dan 12: 00-a çenli',
      break_time: 'Arakesme 13: 00-dan 14: 00-a çenli',
      number_inquiries: 'Habarlaşmak üçin',
      rights_reserved: 'Ähli hukuklar goralan',
      write_admin: 'Adminstratora hat ýazmak',
      confirmed_year: 'Tassyklanan ýyly',
      document_sample: 'Resminamalaryň nusgalary',
      hearing_list: 'Nägilelik we gözegçilik tertibinde seretmäge bellenen işleriň sanawy',
      complaint: 'Nägilelik tertibinde seretmäge bellenen işleriň sanawy',
      control: 'Gözegçilik tertibinde seretmäge bellenenişleriň sanawy',
      complaint_board: 'Türkmenistanyň kazyýetleriniň çözgütlerine,hökümlerine we gaýry kararlaryna şikaýat etmegiň tertibi',
      video: 'Wideo',
      view_all: 'Hemmesini görmek',
      commission_basis: 'Başlangyç bahasy',
      court_order: 'Kazyýetiň karary esasynda',
      contact_us: 'Habarlaşmak üçin',
      active: 'Açyk',
      closed: 'Tamamlandy',
      property: 'Emläk',
      all_button: 'Giňişleýin',
      full: 'Doly oka',
      last_news: "Soňky täzelikler",
      history: 'Kazyýetiň taryhy',
      // login 
      personal_account: "Şahsy otag",
      please: "Şahsy otaga girmek üçin hasaba alynmagyňyzy haýyş edýäris",
      log_in: "Içeri girmek",
      registration: "Hasaba alyş",
      forgot: "Açar söz yadyňyzdan çykdymy?",
      phone: "Telefon nomer",
      phone_last: "xx xxxxxx",
      password: "Açar söz",
      required_phone: "Telefon nomer dogry bolmaly",
      min_phone: "minimum 8 simbol bolmaly",
      max_phone: "mixsimum 8 simbol bolmaly",
      required_password: "Açar söz hökman bolmaly",
      min_password: "minimum 5 simbol bolmaly",
      max_password: "minimum 50 simbol bolmaly",
      only_number: "Diňe san bolmaly!",
      other: 'Beýlekiler',
      username: "Ulanyjy ady",
      no_account: "Hasabyňyz ýokmy?",
      required: "Hökmany doldurmaly",
      invalid_email: "Email dogry bolmaly",
      password_min_length: "Açar söz azyndan 6 simwol bolmaly",
      passwords_not_match: "Açar sözler gabat gelenok",
      log_in_invalid: "Ulanyjy ady ýa-da açar söz nädogry",
      show: "Görkez",
      hide: "Gizle",
      // registration
      please_registration: "Şahsy otaga girmek üçin hasaba alynyň!",
      name: "Ady",
      company_name: "Edaranyň ady",
      surname: "Familýasy",
      patronymic: "Atasynyň ady",
      email: "Email",
      repeat_password: "Açar sözüni gaytalaň",
      create_account: "Hasap doretmek",
      have_account: "Hasap barmy? ",
      some_text1:
        "Şahsy otaga girmek üçin hasaba alynyň!",
      not_password: "Açar sözüňiz gabat gelmeýär",
      physical: "Fiziki tarap",
      juridical: "Ýüridiki tarap",
      birth: "Doglan senesi",
      verify: "SMS tassyklamak",
      verify_send: "Ugratmak",
      code: "Kod",
      try: "Ýene bir gezek synanyşyň",
      all_must: 'Ähli meýdançany hökmany doldyrmaly!',
      success: 'Üstünlikli boldy!',
      not_success: 'Üstünlikli bolmady!',
      log_out_of_system: 'Siz ulgamdan çykdyňyz!',
      log_in_system: 'Siz üstünlikli ulgama girdiňiz!',
      please_try: 'Täzeden synanyşyp görmegiňizi haýyş edýäris',
      password_success: 'Açar sözi üstünlikli üýtgedildi!',
      appeal_success: 'Siziň ýüz tutmaňyz üstünlikli ugradyldy!',
      close: 'Çykmak',
      app_procedurePhysical: 'Fiziki şahslar elektron ýüz tutmak üçin şu aşakdaky ädimleri ýerine ýetirmeli:',
      app_procedureJudicial: 'Ýuridiki şahslar elektron ýüz tutmak üçin şu aşakdaky ädimleri ýerine ýetirmeli:',
      app_procedureDefinition: 'Ýokardaky ädimleri ýerine ýetireniňizden soň, "ibermek" düwmesine basyň. Ondan soň, görünýän penjirede telefon belgiňize iberilen SMS koduny tassyklaň we "ibermek" düwmesine basyň. Soňra e-poçtaňyz kabul ediler. Siziň elektron ýüz tutmagyňyz Türkmenistanyň “Administratiw proseduralar” kanunyna laýyklykda serediler we netijeler şikaýatda görkezilen salga 1 aýyň içinde habar beriler. Bellik: elektron ýüz tutmany dolduranyňyzda “*” belginiň doldurylmagy, şeýle hem şahsyýetnama talap edilýär, şahsyýetiňizi tassyklaýan islendik resminamanyň elektron nusgasyny goşmagyňyzy haýyş edýäris.',
      app_organisation: 'Edaranyň ady;',
      app_position: 'Wezipesi;',
      app_name: 'Adyňyzy giriziň;',
      app_surname: 'Familiýaňyzy giriziň;',
      app_patronimic: 'Ataňyzyň adyny giriziň;',
      app_province: 'Welaýat saýlaň;',
      app_district: 'Etrap saýlaň;',
      app_appeal: 'Ýüz tutmanyň görnüşini saýlaň!',
      app_address: 'Salgyňyzy giriziň;',
      app_phone: 'Telefon belgiňizi giriziň;',
      app_email: 'Email salgyňyzy giriziň;',
      app_message: 'Hat galdyryň;',
      app_file: 'Faýl saýlaň',

      // app_court: 'Выберите суд, в который хотите обратиться;',
      // app_place: 'Место, где нарушены права;',
    },
  },
  ru: {
    translation: {
      layoutHome: 'Президент Туркменистана Сердар Бердымухамедов:',
      layoutHome2: '',
      // navbar
      home: 'Главная',
      laws_codes: 'Нормативные правовые акты',
      about: 'О суде',
      online_services: 'Онлайн услуги',
      services: 'Услуги',
      news: 'Пресс центр',
      contacts: 'Адреса',
      sign_in: 'Войти',
      tm_laws: 'Законы Туркменистана',
      tm_codex: 'Кодексы Туркменистана',
      tm_constitution: 'Конституция Туркменистана',
      tm_constitutionlaws: 'Конституция Туркменистана',
      darkmode: 'Темный Режим',
      lightmode: 'Яркий Режим',
      // pages
      all_news: 'Все новости',
      photomaterials: 'Фотоматериалы',
      useful_sites: 'Полезные сайты',
      branches: 'Судебные учреждения',
      confiscated: 'Конфискованные имущества',
      appeals: 'Онлайн oбращения',
      online_appeals: 'Обращения',
      state_duty: 'Государственная пошлина',
      collection_decisions: "Постановления Пленума Верховного суда Туркменистана",
      legal_assistance: 'Юридическая помощь',
      legal_assistance_desc: 'Mы готовы найти для вас необходимую информацию в любое время',
      faq: 'Часто задаваемые вопросы',
      auction: 'Аукцион',
      country_news: 'Hовости страны',
      judicial_news: 'Hовости судебных органов',
      article: 'Cтатья',
      event: 'Mероприятиe',
      media: 'Mедиа',
      personal_room: 'Личный кабинет',
      personal_inform: 'Персональные данные',
      profile: 'Профиль',
      auction_appeals: 'Aукционные обращения',
      logout: 'Bыйти',
      RECEIPT: 'Kвитанция',
      ONLINE: 'Онлайн',
      ACCEPTED: 'Принято',
      REJECTED: 'Отклонен',
      IN_PROGRESS: 'B прогрессе',
      full_name: 'Полное имя',
      property_name: 'Имя свойства',
      content: 'Cодержание',
      date: 'Дата',
      status: 'Статус',
      payment_type: 'Способ оплаты',
      type: 'Tип',
      sale: 'Имущества, продаваемые на основе судебных постановлений',
      select: 'Выбирать',
      select_category: 'Выберите данное учреждение',
      select_type: 'Выберите тип',
      judgment: 'Cуждение',
      solution: 'Решение',
      definition: 'На основании решения суда',
      price: 'Цена',
      min_price: 'Цена: мин',
      max_price: 'Цена: мах',
      search: 'Поиск',
      search_result: 'Результат поиска:',
      info: 'Информация',
      legal_status: 'Правовой статус',
      ARRESTED: 'Арестован',
      organizer: 'Организатор',
      telephone: 'Телефон',
      address: 'Адрес',
      closing_date: 'Дата окончания приема заявок',
      trading_date: 'Дата проведения конкурсных торгов',
      trading_place: 'Место проведения',
      apply: 'Подать заявку',
      calculator: 'Калькулятор',
      count: 'Считать!',
      calculation_type_label: 'Выберите виды расчета судебных сборов',
      is_working: 'Плательщик работает?',
      payers_salary: 'Заработная плата плательщикa (без учета подоходного налога)',
      child_number: 'Количество детей',
      average_salary: 'Утвержденная средняя заработная плата 2025 года',
      paid_alimony: 'Размер алиментов к выплате',
      calculated: 'Рассчитывается на основе предоставленной вами информации',
      nothing_found: 'Ничего не найдено',
      yes: 'Да',
      no: 'Нет',
      application_procedure: 'Порядок обращения',
      institution_name: 'Название учебного заведения',
      job: 'Должность',
      select_province: 'Выберите провинцию',
      select_county: 'Выберите округ',
      write_name: 'Напишите имя',
      write_surname: 'Напишите фамилию',
      write_patronymic: 'Напишите отчество',
      write_address: 'Напишите адресс',
      your_message: 'Ваш сообщения',
      choose_file: 'Выберите файл',
      attach_file: 'Прикрепите файлы, если они у вас есть',
      send: 'Отправить',
      chosen: 'Выбранные файлы',
      appeal_type: 'Выберите тип обращения',
      birthday: 'День рождения',
      passport_copy: 'Пасспорт копия',
      duty_amount: 'Суммы фиксированной государственной пошлины',
      phone_number: 'Номер телефона',
      show_map: 'Показать в карте',
      supreme_court: 'Верховный Cуд',
      turkmenistan: 'Туркменистана',
      save: 'Сохранить',
      check: 'Проверить',
      request_copies: 'Запрос о предоставлении копий судебных актов',
      list_cases: 'Списки дел, назначенных к слушанию',
      recipient: 'Получатель',
      law_help: 'Порядок приема граждан',
      accept_time: 'Время принятия',
      receiving_citizens: 'Порядок приема граждан',
      receiving_time_days: 'C понедельника по пятницу с 09:00 до 16:00',
      receiving_time_week: 'Суббота с 09:00 до 12:00',
      break_time: 'Перерыв на обед с 13:00 до 14:00',
      number_inquiries: 'Номер для справок из верховного суда Туркменистана',
      write_admin: 'Написать администратору',
      rights_reserved: 'Все права защищены',
      confirmed_year: 'Год утверждения',
      document_sample: 'Образцы документов',
      hearing_list: 'Список дел назначенные на рассмотрение в касационном и надзорном порядке',
      complaint: 'Список дел назначенные на рассмотрение в касационном порядке',
      control: 'Список дел назначенные на рассмотрение в надзорном порядке',
      complaint_board: 'Порядок обжалования решений, приговоров и иных постановлений судов Туркменистана',
      video: 'Видео',
      view_all: 'Посмотреть все',
      commission_basis: 'Начальная цена',
      court_order: 'На основании решения суда',
      contact_us: 'Связаться с нами',
      active: 'Активный',
      closed: 'Закрытый',
      property: 'Имушество',
      all_button: 'Подробнее',
      full: 'Читать далее',
      last_news: "Последние новости",
      history: 'История суда',
      // login 
      personal_account: "Личный кабинет",
      please: "Для входа в кабинет, пожалуйста, авторизуйтесь",
      log_in: "Войти в систему",
      registration: "Регистрация",
      forgot: "Забыли пароль?",
      phone: "Телефон",
      phone_last: "xx xxxxxx",
      password: "Пароль",
      required_phone: "Должен быть номер телефона",
      min_phone: "должно быть не менее 8 символов",
      max_phone: "Должно быть не более 8 символов",
      required_password: "Пароль обязателен",
      min_password: "должно быть не менее 5 символов",
      max_password: "Должно быть не более 50 символов",
      only_number: "Религия должна быть номером!",
      other: 'Другие',
      username: "Имя пользователя",
      no_account: "У вас нет аккаунта?",
      required: "Обязательное поле",
      invalid_email: "Неверный email",
      password_min_length: "Пароль должен содержать минимум 6 символов",
      passwords_not_match: "Пароли не совпадают",
      log_in_invalid: "Неверное имя пользователя или пароль",
      show: "Показать",
      hide: "Скрыть",
      // registration
      please_registration: "Для входа в кабинет, пожалуйста, зарегистрируйтесь",
      name: "Имя",
      company_name: "Название компании",
      surname: "Фамилия",
      patronymic: "Отчество",
      email: "Маил",
      repeat_password: "Повторите пароль",
      create_account: "Создать аккаунт",
      have_account: "Есть аккаунт? ",
      some_text1:
        "Зарегистрируйтесь, чтобы получить доступ к приватной комнате!",
      not_password: "Ваш пароль не подходит",
      physical: "Физический",
      juridical: "Юридический",
      // verify
      verify: "Проверка",
      verify_send: "Отправить",
      code: "Код",
      try: "Повторите еще раз",
      birth: "День рождения",
      success: 'Успешно!',
      not_success: 'Не успешно!',
      log_out_of_system: 'Вы вышли из системы!',
      log_in_system: 'Вы успешно вошли в систему!',
      please_try: 'Пожалуйста попробуйте еще раз',
      password_success: 'Пароль успешно изменен!',
      appeal_success: 'Ваше обращение успешно отправлено!',
      close: 'Выход',
      app_procedurePhysical: ' Для подачи электронного обращения физических лиц просим выполнить последовательно следующие действия:',
      app_procedureJudicial: ' Для подачи электронного обращения юридического лица просим выполнить последовательно следующие действия',
      app_procedureDefinition: ' После выполнения вышеуказанных действий, нажмите на кнопку «отправить». После этого, подтвердите отправленный смс код на Ваш телефонный номер в появившееся окно и нажмите на кнопку «отправить». После этого ваше электронное обращение будет принято. Ваше электронное обращение будет рассмотрено в соответствии Закону Туркменистана «Об административных процедурах» и будет сообщено о результатах в течении 1 месяца по указанному адресу в обращении.Примечание: при заполнении электронного обращения пункты со знаком «*» обязательны для заполнения, так же для удостоверения личности просим Вас прикрепить электронную копию любого документа удостоверяющий Вашу личность.',
      app_organisation: 'Ваше наименование;',
      app_position: 'Должность;',
      app_name: 'Введите ваше имя;',
      app_surname: 'Введите свою фамилию;',
      app_patronimic: 'Введите своё отчество;',
      app_province: 'Выберите велаят;',
      app_district: 'Выберите этрап;',
      app_appeal: 'Выберите тип обращения',
      app_address: 'Введите свой адрес;',
      app_phone: 'Введите свой номер телефона;',
      app_email: 'Введите ваш адрес электронной почты;',
      app_message: 'Текст обращения;',
      app_file: 'Прикрепите файлы.',
    },
  },
  en: {
    translation: {
      layoutHome: 'President of Turkmenistan Serdar Berdimuhamedow:',
      layoutHome2: '',
      // navbar
      home: 'Home',
      laws_codes: 'Regulatory legal acts',
      about: 'About court',
      online_services: 'Online services',
      services: 'Services',
      news: 'Press center',
      contacts: 'Addresses',
      sign_in: 'Log in',
      tm_laws: 'Laws of Turkmenistan',
      tm_codex: 'Codes of Turkmenistan',
      tm_constitution: 'Constitution of Turkmenistan',
      tm_constitutionlaws: 'Constitution of Turkmenistan',
      darkmode: 'Dark Mode',
      lightmode: 'Light Mode',
      // pages
      all_news: 'All news',
      photomaterials: 'Photo materials',
      useful_sites: 'Useful sites',
      branches: 'Judicial institutions',
      confiscated: 'Confiscated properties',
      appeals: 'Appeals',
      online_appeals: 'Online appeals',
      state_duty: 'Court fees',
      collection_decisions: "Collection of Resolutions of the Plenum of the Supreme Court of Turkmenistan",
      legal_assistance: 'Legal assistance',
      legal_assistance_desc: 'We are ready to find needed information for you any time',
      faq: 'Frequently asked questions',
      auction: 'Auction',
      country_news: 'Country news',
      judicial_news: 'Judicial news',
      article: 'Article',
      event: 'Events',
      media: 'Media',
      personal_room: 'Personal room',
      personal_inform: 'Personal informations',
      profile: 'Profile',
      auction_appeals: 'Auction appeals',
      logout: 'Log out',
      RECEIPT: 'Receipt',
      ONLINE: 'Online',
      ACCEPTED: 'Accepted',
      REJECTED: 'Rejected',
      IN_PROGRESS: 'In progress',
      full_name: 'Full name',
      property_name: 'Property name',
      content: 'Content',
      date: 'Date',
      status: 'Status',
      payment_type: 'Payment type',
      type: 'Type',
      sale: 'Property sale by court order',
      select: 'Select',
      select_category: 'Select given institution',
      select_type: 'Select a type',
      judgment: 'Judgment',
      solution: 'Solution',
      definition: 'Based on a court order',
      price: 'Price',
      min_price: 'Price: min',
      max_price: 'Price: max',
      search: 'Search',
      search_result: 'Search result:',
      info: 'Information',
      legal_status: 'Legal status',
      ARRESTED: 'Arrested',
      organizer: 'Organizer',
      telephone: 'Phone number',
      address: 'Address',
      closing_date: 'Closing date of applications',
      trading_date: 'Date for competitive bidding',
      trading_place: 'Place',
      apply: 'Apply',
      calculator: 'Calculator',
      count: 'Count!',
      calculation_type_label: 'Select types of calculation of court fees',
      is_working: 'Is the payer working?',
      payers_salary: "Payer's salary (excluding income tax)",
      child_number: 'Number of children',
      average_salary: 'Approved average salary of 2025 year',
      paid_alimony: 'Amount of alimony to be paid',
      calculated: 'Calculated based on the information you provide',
      nothing_found: 'Nothing found',
      yes: 'Yes',
      no: 'No',
      application_procedure: 'Application procedure',
      institution_name: 'Institution name',
      job: 'Job title',
      select_province: 'Select province',
      select_county: 'Select county',
      write_name: 'Write your name',
      write_surname: 'Write your surname',
      write_patronymic: 'Write your patronymic',
      write_address: 'Write your address',
      your_message: 'Your message',
      choose_file: 'Choose file',
      attach_file: 'Attach file if you have them',
      send: 'Send',
      chosen: 'Chosen files',
      appeal_type: 'Select type of appeal',
      birthday: 'Birthday',
      passport_copy: 'Passport copy',
      duty_amount: 'Amounts of fixed state tax',
      phone_number: 'Phone number',
      show_map: 'Show on map',
      supreme_court: 'Supreme Court',
      turkmenistan: 'of Turkmenistan',
      save: 'Save',
      check: 'Check',
      request_copies: 'Request for copies of judicial acts',
      list_cases: 'Lists of cases scheduled for hearing',
      recipient: 'Recipient',
      law_help: 'Procedure for receiving citizens',
      accept_time: 'Accept time',
      receiving_citizens: 'Procedure for receiving citizens',
      receiving_time_days: 'From Monday to Friday from 09:00 to 16:00',
      receiving_time_week: 'Saturday from 09:00 to 12:00',
      break_time: 'Breaktime from 13:00 to 14:00',
      number_inquiries: 'Number for inquiries from the Supreme Court of Turkmenistan',
      write_admin: 'Write to administrator',
      rights_reserved: 'All rights reserved',
      confirmed_year: 'Year approved',
      document_sample: 'Document samples',
      hearing_list: 'List of cases scheduled for consideration in the cassation and supervisory procedure',
      complaint: 'List of cases scheduled for consideration in the cassation procedure',
      control: 'List of cases scheduled for consideration in the supervisory procedure',
      complaint_board: 'Procedure for appealing decisions, judgments and other decisions of the courts of Turkmenistan',
      video: 'Video',
      view_all: 'View all',
      commission_basis: 'Starting price',
      court_order: 'Based on a court order',
      contact_us: 'Contact us',
      active: 'Active',
      closed: 'Closed',
      property: 'Property',
      all_button: 'More',
      full: 'Read more',
      last_news: "Last news",
      history: 'Court History',
      // login
      personal_account: "Personal account",
      please: "To enter the cabinet, please log in",
      log_in: "Log in",
      registration: "Registration",
      forgot: "Forgot password?",
      phone: "Phone number",
      phone_last: "xx xxxxxx",
      password: "Password",
      required_phone: "Phone number is required",
      min_phone: "Must be at least 8 characters long",
      max_phone: "Must be no more than 8 characters",
      required_password: "Password is required",
      min_password: "Must be at least 5 characters long",
      max_password: "Must be no more than 50 characters",
      only_number: "Religion should be the number!",
      other: 'Others',
      username: "Username",
      no_account: "Don't have an account?",
      required: "Required field",
      invalid_email: "Invalid email",
      password_min_length: "Password must be at least 6 characters",
      passwords_not_match: "Passwords do not match",
      log_in_invalid: "Invalid username or password",
      show: "Show",
      hide: "Hide",
      // registration
      please_registration: "To enter the cabinet, please register",
      name: "Name",
      company_name: "Company name",
      surname: "Surname",
      patronymic: "Fathers name",
      email: "Email",
      repeat_password: "Repeat password",
      create_account: "Create account",
      have_account: "Already have account? ",
      some_text1:
        "Sign up for accessing private room!",
      not_password: "Your password doesn't fit",
      physical: "Physical",
      juridical: "Juridical",
      birth: "Date of birth",
      verify: "SMS verification",
      verify_send: "Send",
      code: "Code",
      try: "Try again",
      success: 'Successfully!',
      not_success: 'Not successfully!',
      log_out_of_system: 'You logged out of system!',
      log_in_system: 'You logged in successfully!',
      please_try: 'Please try again',
      password_success: 'Password changed successfully!',
      appeal_success: 'Your appeal sent successfully!',
      close: 'Close',
      app_procedurePhysical: 'To submit an electronic application from individuals, please complete the following steps in sequence:',
      app_procedureJudicial: 'To submit an electronic request from a legal entity, please follow these steps in sequence:',
      app_procedureDefinition: 'After completing the above steps, click on the "send" button. After that, confirm the SMS code sent to your phone number in the window that appears and click on the "send" button. After that, your electronic request will be accepted. Your electronic request will be reviewed in accordance with the Law of Turkmenistan "On Administrative Procedures" and the results will be reported within 1 month to the address specified in the request. Note: when filling out an electronic request, items marked with "*" are mandatory, also for identification, we ask you to attach an electronic copy of any document proving your identity.',
      app_organisation: 'Organization name;',
      app_position: 'Position;',
      app_name: 'Enter your name;',
      app_surname: 'Please enter your last name;',
      app_patronimic: 'Enter your patronymic;',
      app_province: 'Select a province;',
      app_district: 'Select an etrap;',
      app_appeal: 'Select the type of request;',
      app_address: 'Enter your address;',
      app_phone: 'Enter your phone number;',
      app_email: 'Enter your email address;',
      app_message: 'Text of the appeal;',
      app_file: 'Attach files.',
    },
  },
};
